import Image from 'next/image';
import Link from 'next/link';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';
import React, { useEffect, useRef, useState } from 'react';

export default function pnewsbox(props) {
  /**
   *  
   * 1."text_color":"b",   의 의미 ??  타입 대신 쓰임
   * 2. 링크주소 정리 
   * 3. talk 서비스 주소 정의
   * 
   */
  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);
  //link로그를
  const handleClick = (a,b,c,d,e) => {
    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    //alert(d);
    let conver_current_s= (parseInt(c));
    let conver_current_s2 = (parseInt(props.loc_idx));


    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: '기사', //모듈 아이디 없으면
        moduleTitle: '스브스프리미엄', //모듈 제목 (Require)
        moduleSubTitle: '',
        moduleActive: 'C', //콘텐츠 선택 정보 Click: C, Hover: H
        moduleSeq: conver_current_s2, //페이지에서 해당 모듈의 위치
        moduleItemSeq: conver_current_s, //모듈 내에서 콘텐츠의 위치
        programId: '', //프로그램의 아이디 (추가)
        programTitle: d, //프로그램의 아이디 (추가)
        contentId: '스브스프리미엄',//식별자
        contentTitle: b.title, //콘텐츠의 제목  (Require)
        contentNumber: '',
        contentType: 'AR', //콘텐츠의 타입 (별도 표 참조)
      }
    });
  };

  const handleClick_custom = (a,b,c,d) => {

    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '스브스프리미엄 전체보기',
        clickType: 'NC',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: ''
      }
    });

  };


  return (

    <>
      {/* <!-- 화이트 배경 -->*/}
      <div className="mainContents-typeWhite" >
        {/* <!-- 스브스프리미엄 -->*/}
        <div className="contentsBlock_w" >
          <div className="moduleTitleline_w">
            <h2 className="moduleTitleline-Title">{props.data.list_title}</h2>
            <a href={props.data.alllink_url}   onClick={(e) => handleClick_custom(e, '','0','all')} target="_blank" className="moduleTitleline-linkMore" style={{ visibility: (props.data.alllink_yn == 'Y' && props.data.alllink_url != '' && props.data.alllink_url != null) ? 'visible' : 'hidden' }}>{props.data.alllink_title}</a>
          </div>
          <div className={"listModule_w_news news" + props.loc_idx}>
            <div className="listModuleSlider listScrollSlider">
              {/* <!-- 리스트 -->*/}
              <div className="SliderContent swiper-wrapper">

                {
                  props.data.contents.map((item, index) => {
                    return (
                      <div className="listModuleItem swiper-slide">
                        <div className="moduleBoxWrap_news">
                          <Link href={item.link_url} >
                            <a   onClick={(e) => handleClick(e, item,index,item.sub_title,'인기')}  target={item.link_new_yn == 'Y' ? '_blank' : ''} className="mb_link">
                              <div className="mb_image_w">
                                <div className="mb_image_inner">
                                  <img src={item.img_url} className="mb_image" alt={item.img_attr} />
                                </div>
                              </div>
                              <div className="mb_info_w">
                                <span className="mbif_title">{item.title}</span>
                                <span className="mbif_subinfo">{item.sub_title}</span>
                              </div>
                            </a>
                          </Link>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  );

}